import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppAirflow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	preserveAspectRatio: "xMidYMid",
	viewBox: "0 0 256 256",
	style: { filter: "grayscale(1) brightness(150%)" },
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "a",
				cx: "0%",
				cy: "100%",
				r: "120.116%",
				fx: "0%",
				fy: "100%",
				gradientTransform: "translate(0 .167) scale(.83253)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#00C812"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#006E00"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "b",
				cx: "0%",
				cy: "0%",
				r: "120.116%",
				fx: "0%",
				fy: "0%",
				gradientTransform: "matrix(0 .83253 -.83253 0 0 0)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#56AFFD"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#04A3FF"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "c",
				cx: "100%",
				cy: "0%",
				r: "120.116%",
				fx: "100%",
				fy: "0%",
				gradientTransform: "matrix(-.83253 0 0 -.83253 1.833 0)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#DF1F00"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#560D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "d",
				cx: "100%",
				cy: "100.001%",
				r: "120.116%",
				fx: "100%",
				fy: "100.001%",
				gradientTransform: "matrix(0 -.83254 .83253 0 .167 1.833)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#00FFFD"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#00DAFF"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "e",
				cx: "0%",
				cy: "100%",
				r: "100%",
				fx: "0%",
				fy: "100%",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#008200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#007500"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "f",
				cx: "0%",
				cy: "0%",
				r: "100%",
				fx: "0%",
				fy: "0%",
				gradientTransform: "matrix(0 1 -1 0 0 0)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#3166D4"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#1A509E"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "g",
				cx: "100%",
				cy: "0%",
				r: "100%",
				fx: "100%",
				fy: "0%",
				gradientTransform: "matrix(-1 0 0 -1 2 0)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#8E1400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#4B0B00"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "h",
				cx: "100%",
				cy: "100.001%",
				r: "99.999%",
				fx: "100%",
				fy: "100.001%",
				gradientTransform: "matrix(0 -1 1 0 0 2)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#0090C4"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#005D8C"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "i",
				cx: "0%",
				cy: "99.999%",
				r: "100%",
				fx: "0%",
				fy: "99.999%",
				gradientTransform: "matrix(1 0 0 .99999 0 0)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#00CD1C"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#00E950"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "j",
				cx: "0%",
				cy: "0%",
				r: "100%",
				fx: "0%",
				fy: "0%",
				gradientTransform: "rotate(90)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#B1C8FD"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#7EC3FD"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "k",
				cx: "100%",
				cy: "0%",
				r: "100%",
				fx: "100%",
				fy: "0%",
				gradientTransform: "matrix(-1 0 0 -1 2 0)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#E12A00"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#B62F00"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "l",
				cx: "100%",
				cy: "100%",
				r: "99.998%",
				fx: "100%",
				fy: "100%",
				gradientTransform: "matrix(0 -1 1.00002 0 0 2)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					stopColor: "#00B6DD"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					stopColor: "#0FF"
				})]
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#a)",
			d: "M179.2 230.4H256L133.12 128c-1.687 37.193 14.687 73.58 46.08 102.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#b)",
			d: "M25.6 179.2V256L128 133.12a115.427 115.427 0 0 0-5.225-.118c-35.36.002-69.708 16.279-97.175 46.198"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#c)",
			d: "M0 25.6 122.88 128c1.687-37.192-14.687-73.58-46.08-102.4H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#d)",
			d: "M230.4 0 128 122.879c37.193 1.688 73.58-14.687 102.4-46.08V0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#e)",
			d: "M128 128c-11.479 29.755-9.745 60.086 5.12 89.601 15.36 7.679 28.16 12.799 46.08 12.799-31.393-28.82-47.767-65.207-46.08-102.4H128Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#f)",
			d: "M38.4 133.12c-7.679 15.361-12.8 28.16-12.8 46.08 28.819-31.393 65.207-47.766 102.4-46.08V128c-12.944-4.993-25.994-7.486-39.04-7.486-16.946.001-33.884 4.207-50.56 12.606"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#g)",
			d: "M122.88 128H128c11.478-29.755 9.745-60.087-5.12-89.6-15.36-7.68-28.159-12.8-46.08-12.8 31.393 28.82 47.767 65.208 46.08 102.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#h)",
			d: "M128 122.879V128c29.755 11.478 60.086 9.744 89.6-5.121 7.68-15.358 12.8-28.158 12.8-46.08-28.82 31.393-65.207 47.768-102.4 46.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#i)",
			d: "m71.68 166.4 61.44 51.201C118.255 188.086 116.521 157.755 128 128c-1.776-.592-3.858-.876-6.158-.876-17.599.001-47.898 16.635-50.162 39.276"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#j)",
			d: "M38.4 133.12c29.514-14.865 59.845-16.598 89.6-5.12 5.12-15.359-12.8-53.76-38.4-56.32l-51.2 61.44Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#k)",
			d: "M128 128c15.36 5.12 53.759-12.8 56.32-38.4l-61.44-51.2c14.865 29.513 16.598 59.845 5.12 89.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#l)",
			d: "M128 128c-5.12 15.361 12.8 53.76 38.4 56.32l51.2-61.441c-29.514 14.865-59.845 16.599-89.6 5.121"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M128 121.6a6.4 6.4 0 1 1 0 12.8 6.4 6.4 0 0 1 0-12.8" })
	]
});
export default SvgAppAirflow;
